import React from 'react';

import Name from '../utility/Name.jsx';
import { BaseText } from './Text.jsx';
import Token from '../utility/Token.jsx';
import TypeConfig from '../utility/TypeConfig.jsx';

import { default as ClickToken } from '../../../../../artcloud.click/source/scripts/common/Token.jsx';

function FooterComponent(props) {
    const parseContent = (tokenizedString) => {
        if (!tokenizedString) {
            return '';
        }
        return ClickToken.parseTokenizedString(tokenizedString, (keyword) => {
            let replaceString = '';
            switch (keyword) {
                case Token.Footer.CurrentYear:
                case Token.Footer.ListAddressHtml:
                case Token.Footer.ListCompany:
                    replaceString = `*|${keyword}|*`
                    break;
            }
            return replaceString;
        });
    }
    const design = props.blockConfig && props.blockConfig.block && props.blockConfig.block.design;
    const [content, setContent] = React.useState(undefined);
    React.useEffect(() => {
        setContent(parseContent(props.blockConfig.block.design));
    }, [design]);

    let linkTextDecoration = 'none';
    let textDecoration = 'none';
    let unsubscribeContainerStyle = '';
    let unsubscribeLinkStyle = '';
    if (props.blockConfig && props.blockConfig.unsubscribe) {
        for (let propName in props.blockConfig.unsubscribe) {
            const prop = props.blockConfig.unsubscribe[propName];
            let propValue = prop;
            if (propValue == undefined) {
                continue;
            }
            if (propValue.unit) {
                propValue = `${prop.value.trim()}${prop.unit}`;
            } else if (propValue != true && propValue != false) {
                propValue = propValue.trim();
            }
            if (propValue === '') {
                continue;
            }
            switch (propName) {
                case 'borderBottomColor':
                    unsubscribeContainerStyle += `border-bottom-color:${propValue};`
                    break;
                case 'borderBottomStyle':
                    unsubscribeContainerStyle += `border-bottom-style:${propValue};`
                    break;
                case 'borderBottomWidth':
                    unsubscribeContainerStyle += `border-bottom-width:${propValue};`
                    break;
                case 'borderLeftColor':
                    unsubscribeContainerStyle += `border-left-color:${propValue};`
                    break;
                case 'borderLeftStyle':
                    unsubscribeContainerStyle += `border-left-style:${propValue};`
                    break;
                case 'borderLeftWidth':
                    unsubscribeContainerStyle += `border-left-width:${propValue};`
                    break;
                case 'borderRightColor':
                    unsubscribeContainerStyle += `border-right-color:${propValue};`
                    break;
                case 'borderRightStyle':
                    unsubscribeContainerStyle += `border-right-style:${propValue};`
                    break;
                case 'borderRightWidth':
                    unsubscribeContainerStyle += `border-right-width:${propValue};`
                    break;
                case 'borderTopColor':
                    unsubscribeContainerStyle += `border-top-color:${propValue};`
                    break;
                case 'borderTopStyle':
                    unsubscribeContainerStyle += `border-top-style:${propValue};`
                    break;
                case 'borderTopWidth':
                    unsubscribeContainerStyle += `border-top-width:${propValue};`
                    break;
                case 'isBold':
                    if (propValue) {
                        unsubscribeContainerStyle += 'font-weight:bold;';
                    }
                    break;
                case 'isItalic':
                    if (propValue) {
                        unsubscribeContainerStyle += 'font-style:italic;';
                    }
                    break;
                case 'isUnderline':
                    if (propValue) {
                        textDecoration = 'underline';
                    }
                    break;
                case 'paddingBottom':
                    unsubscribeContainerStyle += `padding-bottom:${propValue};`
                    break;
                case 'paddingLeft':
                    unsubscribeContainerStyle += `padding-left:${propValue};`
                    break;
                case 'paddingRight':
                    unsubscribeContainerStyle += `padding-right:${propValue};`
                    break;
                case 'paddingTop':
                    unsubscribeContainerStyle += `padding-top:${propValue};`
                    break;
                case 'color-link':
                    unsubscribeLinkStyle += `${propName.replace('-link', '')}:${propValue};`
                    break;
                case 'isBold-link':
                    unsubscribeLinkStyle += `font-weight:${propValue ? 'bold' : 'normal'};`;
                    break;
                case 'isItalic-link':
                    unsubscribeLinkStyle += `font-style:${propValue ? 'italic' : 'normal'};`;
                    break;
                case 'isUnderline-link':
                    linkTextDecoration = propValue ? 'underline' : 'none';
                    unsubscribeLinkStyle += `text-decoration:${linkTextDecoration};`;
                    break;
                case 'font-size':
                    if (prop.value < 9) {
                        propValue = '9px';
                    }
                // Intentional fallthrough
                default:
                    unsubscribeContainerStyle += `${propName}:${propValue};`
                    break;
            }
        }
    }
    if (unsubscribeContainerStyle.indexOf('font-family') < 0) {
        unsubscribeContainerStyle += `font-family:${TypeConfig.defaultFontFamily};`
    }
    if (unsubscribeLinkStyle.indexOf('color') < 0) {
        unsubscribeLinkStyle += 'color:inherit;'
    }
    if (unsubscribeLinkStyle.indexOf('text-decoration') < 0) {
        unsubscribeLinkStyle += 'text-decoration:none;'
    }
    if (linkTextDecoration == textDecoration) {
        unsubscribeContainerStyle += `text-decoration:${textDecoration};`
    }
    let _content = content || '';
    _content += `<table border="0" cellpadding="0" cellspacing="0" style="${unsubscribeContainerStyle}" width="100%"><tbody><tr><td><p style="margin:0;padding:0;text-decoration:${textDecoration};">Want to change how you receive these emails?</p><p style="margin:0;padding:0;"><span style="text-decoration:${textDecoration};">You can</span> <a href="-unsubUrl-" style="${unsubscribeLinkStyle}">unsubscribe from this list</a></p>`
    if (props.renderWatermark) {
        const watermarkLink = 'https://artcloud.com/manager-for-artists';
        const watermarkTextStyle = 'color:#898989;font-family:Lato,Roboto,Helvetica,Arial;font-size:15px;margin:0;';
        _content += `<p style="${watermarkTextStyle}padding:28px 0 9px 0;">POWERED BY</p><figure class="image" style="display:inline-block;margin:0 auto;"><a href="${watermarkLink}" alt="ArtCloud"><img alt="ArtCloud" height="48" src="https://artcld-pub.s3.amazonaws.com/assets/campaign/logos/artist-campaign.png" style="height:48px;width:250px;" width="250" /></a></figure><p style="${watermarkTextStyle}padding:18px 0 0 0;"><a href="${watermarkLink}" alt="ArtCloud" style="color:inherit;">Learn more about how ArtCloud empowers the art world.</a></p>`;
    }
    _content += `</td</tr></tbody></table>`;
    return <BaseText.Component {...props} content={_content} />
}
const FooterTokens = () => {
    return [
        Token.getDefaultTokenConfig('Current Year', Token.Footer.CurrentYear),
        Token.getDefaultTokenConfig('List Company', Token.Footer.ListCompany),
        Token.getDefaultTokenConfig('List Address HTML', Token.Footer.ListAddressHtml)
    ]
}
const FooterTypeConfig = {
    defaultDesign: () => `<p class="p" style="margin:0;padding:0;text-align:center;"><span style="color:#ffffff;font-family:${TypeConfig.defaultFontFamily};font-size:12px;font-style:italic;line-height:18px;vertical-align:middle;">Copyright&nbsp;</span><span style="color:#ffffff;font-family:${TypeConfig.defaultFontFamily};font-size:12px;font-style:italic;line-height:18px;vertical-align:middle;" token="${Token.Footer.CurrentYear}">*|${Token.Footer.CurrentYear}|*</span><span style="color:#ffffff;font-family:${TypeConfig.defaultFontFamily};font-size:12px;font-style:italic;line-height:18px;vertical-align:middle;">&nbsp;</span><span style="color:#ffffff;font-family:${TypeConfig.defaultFontFamily};font-size:12px;font-style:italic;line-height:18px;vertical-align:middle;" token="${Token.Footer.ListCompany}">*|${Token.Footer.ListCompany}|*</span><span style="color:#ffffff;font-family:${TypeConfig.defaultFontFamily};font-size:12px;font-style:italic;line-height:18px;vertical-align:middle;">, All rights reserved.</span></p><p class="p" style="margin:0;padding:0;text-align:center;"><span style="font-size:12px;line-height:14px;vertical-align:middle;">&nbsp;</span></p><p class="p" style="margin:0;padding:0;text-align:center;"><span style="font-size:12px;line-height:14px;vertical-align:middle;">&nbsp;</span></p><p class="p" style="margin:0;padding:0;text-align:center;"><span style="font-size:12px;line-height:14px;vertical-align:middle;">&nbsp;</span></p><p class="p" style="margin:0;padding:0;text-align:center;"><span style="color:#ffffff;font-family:${TypeConfig.defaultFontFamily};font-size:12px;font-weight:bold;line-height:18px;vertical-align:middle;">Our mailing address is:</span></p><p class="p" style="margin:0;padding:0;text-align:center;"><span style="color:#ffffff;font-family:${TypeConfig.defaultFontFamily};font-size:12px;line-height:18px;vertical-align:middle;" token="${Token.Footer.ListAddressHtml}">*|${Token.Footer.ListAddressHtml}|*</span></p>`,
    panel: {
        block: () => BaseText.TypeConfig.panel.block({ backgroundColor: TypeConfig.defaultBackgroundColor, design: FooterTypeConfig.defaultDesign() }),
        layout: function () {
            const group = 'layout';
            return {
                group,
                label: 'Layout',
                options: [
                    {
                        display: 'Padding/Margin',
                        group,
                        max: '100',
                        name: 'paddingMargin',
                        options: TypeConfig.options.measurement(),
                        type: 'paddingMargin',
                        value: {
                            paddingBottom: { value: '72', unit: 'px' },
                            paddingLeft: { value: '18', unit: 'px' },
                            paddingRight: { value: '18', unit: 'px' },
                            paddingTop: { value: '9', unit: 'px' }
                        }
                    }
                ]
            }
        },
        unsubscribe: function () {
            const group = 'unsubscribe';
            return {
                group,
                label: 'Unsubscribe',
                options: [
                    {
                        display: 'Font Family',
                        group,
                        name: 'font-family',
                        options: TypeConfig.options.fontFamily(),
                        type: 'dropdown',
                        value: TypeConfig.defaultFontFamily
                    },
                    {
                        display: 'Font Size',
                        group,
                        name: 'font-size',
                        options: TypeConfig.options.measurement(),
                        type: 'measurement',
                        value: { value: '12', unit: 'px' }
                    },
                    {
                        display: 'Line Height',
                        group,
                        name: 'line-height',
                        options: TypeConfig.options.measurement(),
                        type: 'measurement',
                        value: { value: '18', unit: 'px' }
                    },
                    {
                        display: 'Letter Spacing',
                        group,
                        name: 'letter-spacing',
                        options: TypeConfig.options.measurement(),
                        type: 'measurement'
                    },
                    {
                        display: 'Text Color',
                        group,
                        name: 'color',
                        type: 'color',
                        value: '#ffffff'
                    },
                    {
                        display: 'Text Transform',
                        group,
                        name: 'text-transform',
                        options: [
                            { display: 'None', value: 'none' },
                            { display: 'Capitalize', value: 'capitalize' },
                            { display: 'Uppercase', value: 'uppercase' },
                            { display: 'Lowercase', value: 'lowercase' }
                        ],
                        type: 'dropdown',
                        value: 'none'
                    },
                    {
                        display: 'Text Alignment',
                        group,
                        name: 'text-align',
                        options: TypeConfig.options.alignment(),
                        type: 'dropdown',
                        value: 'center'
                    },
                    {
                        group,
                        type: 'spacer'
                    },
                    {
                        display: 'Text Bold',
                        group,
                        name: 'isBold',
                        type: 'checkbox',
                        value: false
                    },
                    {
                        display: 'Text Italic',
                        group,
                        name: 'isItalic',
                        type: 'checkbox',
                        value: false
                    },
                    {
                        display: 'Text Underline',
                        group,
                        name: 'isUnderline',
                        type: 'checkbox',
                        value: false
                    },
                    {
                        group,
                        type: 'spacer'
                    },
                    {
                        display: 'Link Color',
                        group,
                        name: 'color-link',
                        type: 'color'
                    },
                    {
                        group,
                        type: 'spacer'
                    },
                    {
                        display: 'Link Bold',
                        group,
                        name: 'isBold-link',
                        type: 'checkbox',
                        value: false
                    },
                    {
                        display: 'Link Italic',
                        group,
                        name: 'isItalic-link',
                        type: 'checkbox',
                        value: false
                    },
                    {
                        display: 'Link Underline',
                        group,
                        name: 'isUnderline-link',
                        type: 'checkbox',
                        value: false
                    },
                    {
                        display: 'Background/Border Properties',
                        group,
                        id: 'borderProps',
                        type: 'header'
                    },
                    {
                        display: 'Background',
                        group,
                        name: 'background-color',
                        type: 'color'
                    },
                    {
                        display: 'Border Radius',
                        group,
                        name: 'border-radius',
                        options: TypeConfig.options.measurement(true),
                        type: 'measurement'
                    },
                    {
                        display: 'Border',
                        group,
                        name: 'border',
                        options: TypeConfig.options.measurement(),
                        type: 'border'
                    },
                    {
                        display: 'Layout Properties',
                        group,
                        id: 'layoutProps',
                        type: 'header'
                    },
                    {
                        disabled: ['marginLeft', 'marginRight', 'marginBottom', 'marginTop'],
                        display: 'Padding/Margin',
                        group,
                        max: '100',
                        name: 'paddingMargin',
                        options: TypeConfig.options.measurement(),
                        type: 'paddingMargin',
                        value: {
                            paddingBottom: { value: '28', unit: 'px' },
                            paddingTop: { value: '28', unit: 'px' }
                        }
                    }
                ]
            }
        }
    }
}
function FooterBlockTypeDefinition(group) {
    return {
        id: Name.Block.Footer,
        config: {
            block: FooterTypeConfig.panel.block(),
            layout: FooterTypeConfig.panel.layout(),
            unsubscribe: FooterTypeConfig.panel.unsubscribe()
        },
        display: 'Footer',
        group,
        image: 'templates/footer.svg',
        imageFullWidth: true
    };
}
const Footer = { BlockTypeDefinition: FooterBlockTypeDefinition, Component: FooterComponent, Tokens: FooterTokens, TypeConfig: FooterTypeConfig };

export default Footer;